import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
} from '@mui/material';
import { X } from 'lucide-react';
import { TimelineEvent } from '../../types';

interface TimelineNoteDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (note: Omit<TimelineEvent, 'id'>) => void;
}

export const TimelineNoteDialog: React.FC<TimelineNoteDialogProps> = ({
  open,
  onClose,
  onSave,
}) => {
  const [description, setDescription] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({
      date: new Date().toISOString(),
      description,
      type: 'note',
      addedBy: '1', // Current user ID
    });
    setDescription('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Add Timeline Note
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <X size={20} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 3 }}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Note"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            placeholder="Enter your note here..."
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={onClose} color="inherit">
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            Add Note
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};